module.exports = __webpack_public_path__ + "img/keyboard.dd93d0a7.png";